/* Handle transitions
======================================== */
function checkTransition(target){
	if(!$(target).hasClass('transition')){
		$(target).addClass('transition');
		return true;
	}
	return false;
}

/* Slideshow
======================================== */

// Check classes
// const toggleVideoClasses = (video, add, remove) => {
// 	video.addClass(add).removeClass(remove);
// };

// Check videos
// function checkSlideVideo(video, action){

// 	if(video.hasClass('lazyvideo')){
// 		toggleVideoClasses(video, 'lazyloaded', 'lazyvideo');
// 	}

// 	switch(action){
// 		case 'play':
// 			toggleVideoClasses(video, 'is-playing', 'is-paused autoplay-failed');
// 			break;
// 		case 'pause':
// 			toggleVideoClasses(video, 'is-paused', 'is-playing');
// 			video[0].pause();
// 			break;
// 		case 'error':
// 			toggleVideoClasses(video, 'autoplay-failed', 'is-playing');
// 			video[0].pause();
// 			break;
// 		default:
// 			break;
// 	}

// }

// Check slide
// function checkSlide(video, action){
// 	video.is('video') &&
// 		video[0].play()
// 			.then(() => checkSlideVideo(video, action))
// 			.catch(() => checkSlideVideo(video, 'error'));
// }

// Update slider
// function updateSlideshow(slideshow, active, target, dot){

// 	// Current
// 	setTimeout(() => {
// 		active.find('.thumb').each(function(){
// 			checkSlide($(this), 'pause');
// 		});
// 	}, speed);

// 	// New
// 	target.find('.thumb').each(function(){
// 		checkSlide($(this), 'play');
// 	});

// 	// Dots
// 	updateSlideshowDots(dot);

// }

// Update dots
function updateSlideshowDots(dot){
	dot.addClass('active').siblings().removeClass('active');
}

// Prev
function prevSlide(slideshow){
	if(checkTransition(slideshow)){
		let track = slideshow.children('.module-slideshow-track');
		// let active = slideshow.find('.module-slideshow-slide:first-child');
		let target = track.children('.module-slideshow-slide:last-child');
		let dot = slideshow.find('.module-slideshow-dot[data-pos="'+target.data('pos')+'"]');

		// updateSlideshow(slideshow, active, target);
		dot.length && updateSlideshowDots(dot);

		track
			.prepend(target)
			.css('left', '-100%')
			.animate(
		{
			'left': '0'
		}, speed*2, ease, function(){
			slideshow.removeClass('transition');
		});

	}
}
$(document).on('click', '.module-slideshow-prev', function(){
	prevSlide($(this).closest('.module-slideshow'));
}).on('click', '.post-slideshow-prev', function(){
	prevSlide($(this).closest('.post').find('.module-slideshow'));
});

// Next
function nextSlide(slideshow){
	if(checkTransition(slideshow)){
		let track = slideshow.children('.module-slideshow-track');
		let active = track.children('.module-slideshow-slide:first-child');
		let target = active.next();
		let dot = slideshow.find('.module-slideshow-dot[data-pos="'+target.data('pos')+'"]');

		// updateSlideshow(slideshow, active, target);
		dot.length && updateSlideshowDots(dot);

		track
			.animate(
		{
			'left': '-100%'
		}, speed*2, ease, function(){
			track.append(active).css('left', '0');
			slideshow.removeClass('transition');
		});

	}
}
$(document).on('click', '.module-slideshow-next', function(){
	nextSlide($(this).closest('.module-slideshow'));
}).on('click', '.post-slideshow-next', function(){
	nextSlide($(this).closest('.post').find('.module-slideshow'));
});

// Mobile
if(isMobile){

	// // Swipe navigation
	// let xInit = 0;
	// let xEnds = 0;
	// $(document).on('touchstart', '.module-slideshow', function(e){
	// 	xInit = e.changedTouches[0].screenX;
	// }).on('touchend', '.module-slideshow', function(e){
	// 	xEnds = e.changedTouches[0].screenX;
	// 	const distance = xEnds - xInit;
	// 	if(Math.abs(distance) > 50){
	// 		if(distance < 0){
	// 			nextSlide($(this));
	// 		}else{
	// 			prevSlide($(this));
	// 		}
	// 	}
	// });

	// $(document).on('touchstart', '.module-slideshow', function(){
	// 	$(this).find('.module-slideshow-slide .lazyload').addClass('lazypreload');
	// });

	// Track
	$('.module-slideshow-track').scroll(function(){
		const slideshow = $(this).parent();
		if(slideshow.children('.module-slideshow-dots').length){
			if(!slideshow.hasClass('transition')){
				let ww = slideshow.width();
				slideshow.find('.module-slideshow-slide').each(function(){
					let t = $(this);
					let offset = t.position().left - ww/2;
					if(offset <= 0 && offset >= t.width()*-1){
						index = t.data('pos');
					}
				});
				updateSlideshowDots(slideshow.find('.module-slideshow-dot[data-pos="'+index+'"]'));
			}
		}
	});

	// Dots
	$(document).on('click', '.module-slideshow-dot', function(){
		const dot = $(this);
		const slideshow = dot.closest('.module-slideshow');
		const track = slideshow.children('.module-slideshow-track');
		if(checkTransition(slideshow)){

			updateSlideshowDots(dot);

			track.animate({
				scrollLeft: track.find('.module-slideshow-slide:nth-child('+dot.data('pos')+')').position().left + track.scrollLeft()
			}, speed*2, ease);

			setTimeout(function(){
				slideshow.removeClass('transition');
			}, speed*2);
	
		}
	});

// Desktop
}else{

	// // Set active
	// $(document).on('mouseenter mousemove', '.module-slideshow', function(){
	// 	$('.module-slideshow').removeClass('active');
	// 	$(this).addClass('active');
	// }).on('mouseleave', '.module-slideshow', function(){
	// 	$('.module-slideshow').removeClass('active');
	// });

	// // Keyboard navigation
	// document.addEventListener('keyup', (e) => {
	// 	if(e.key == 'ArrowLeft'){
	// 		prevSlide($('.module-slideshow.active'));
	// 	}else
	// 	if(e.key == 'ArrowRight'){
	// 		nextSlide($('.module-slideshow.active'));
	// 	}
	// });

	// $('.module-slideshow').hover(function(){
	// 	$(this).find('.module-slideshow-slide .lazyload').addClass('lazypreload');
	// });

	// Dots
	$(document).on('click', '.module-slideshow-dot', function(){
		let dot = $(this);
		let slider = dot.closest('.module-slideshow');
		// let active = slider.find('.module-slideshow-slide.active');
		let target = slider.find('.module-slideshow-slide[data-pos="'+dot.data('pos')+'"]');
		slider.children('.module-slideshow-track').prepend(target, target.nextAll());
		// updateSlideshow(slider, active, target);
		updateSlideshowDots(dot);
	});

}

// Observer
// let observeSlideshows;
// const observerSlideshows = () => {
// 	observeSlideshows = new IntersectionObserver(entries => {
// 		entries.forEach(entry => {
// 			const slider = entry.target;
// 			const active = slider.querySelectorAll('.module-slideshow-slide:first-child .thumb');
// 			active.forEach(thumb => {
// 				if(entry.isIntersecting){
// 					checkSlide($(thumb), 'play');
// 				}else{
// 					if(!thumb.paused && !thumb.classList.contains('lazyvideo')){
// 						checkSlide($(thumb), 'pause');
// 					}
// 				}
// 			});
// 		});
// 	});
// 	document.querySelectorAll('.module-slideshow').forEach(slideshow => {
// 		observeSlideshows.observe(slideshow);
// 	});
// }
// document.querySelector('.module-slideshow') && observerSlideshows();